import { call, put, takeEvery, select } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';
import { RootState } from '../reducers/rootReducer';
import { getMobilePrinterList, setMobilePrinterList, mobilePrinterListError } from '../actions/mobilePrinter.actions';
import { MOBILE_PRINTERS } from '../../constants';
import { ConfigAuthValues } from '../../types';
import { callAPI } from '../../utils';
import { saveMobilePrinterListFeatureEnabled } from '../../utils/mobilePrinter';

const callGetMobilePrinterList = (storeId: string, configAuthValues: ConfigAuthValues) => {
  const url = `${configAuthValues.APIGEE_BASE_URL}${MOBILE_PRINTERS}`.replace('{storeID}', storeId || '');
  return callAPI({
    method: 'GET',
    url,
  });
};

export function* runGetMobilePrinterListSaga(
  action: ReturnType<typeof getMobilePrinterList>
): Generator<any, void, any> {
  const configAuthValues = yield select((state: RootState) => state.config.authValues);
  const { storeId } = action.payload;

  try {
    if (!storeId) {
      throw new Error('Store ID is required');
    }
    const result = yield call(callGetMobilePrinterList, storeId, configAuthValues);
    if (result.status === 200) {
      saveMobilePrinterListFeatureEnabled('true');
      if (result.data && Array.isArray(result.data)) {
        yield put(setMobilePrinterList({ printers: result.data }));
      } else {
        yield put(mobilePrinterListError({ error: 'Invalid mobile printer list response' }));
      }
    } else if (result.status === 204) {
      saveMobilePrinterListFeatureEnabled('true');
      yield put(mobilePrinterListError({ error: 'No mobile printers found' }));
    }
  } catch (error) {
    if ((error as any)?.response?.status === 501) {
      saveMobilePrinterListFeatureEnabled('false');
    } else {
      const errorMessage = error instanceof Error ? error.message : 'Failed to fetch mobile printer list';
      yield put(mobilePrinterListError({ error: errorMessage }));
      saveMobilePrinterListFeatureEnabled('true');
    }
  }
}

export default function* watchMobilePrinterList() {
  yield takeEvery(getType(getMobilePrinterList), runGetMobilePrinterListSaga);
}
